/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SquareCheckIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="square-check"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.5 5.5C3.5 4.395 4.395 3.5 5.5 3.5L18.5 3.5C19.605 3.5 20.5 4.395 20.5 5.5L20.5 18.5C20.5 19.605 19.605 20.5 18.5 20.5L5.5 20.5C4.395 20.5 3.5 19.605 3.5 18.5L3.5 5.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.14 13.089L10.86 14.809" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.859 14.81A7.961 7.961 0 0 1 14.861 10.008" data-tinysvg-shape="arc" data-tinysvg-arc="18.485 17.097 7.961 7.961 196.694 242.921 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
